import { ConnectedFacility } from '../../api';

export const getConnectionSenderName = (connectionRequest: ConnectedFacility): string => {
  if (connectionRequest.healthcare_entity_rep) {
    const { first_name, last_name } = connectionRequest.healthcare_entity_rep.user;
    return `${first_name} ${last_name}`;
  }
  return 'Auto-Match';
};
